const MUTUAL_GBS_DEPARTMENTS = new Set(['Mutual', 'GBS'])

export const isMutualGbsDepartment = (department) => {
  if (!department) return false
  return MUTUAL_GBS_DEPARTMENTS.has(String(department))
}

const DEFAULT_SAI_TERMS = Object.freeze({
  policy: {
    singularTitle: 'Policy',
    singularLower: 'policy',
  },
  claim: {
    singularTitle: 'Claim',
    pluralTitle: 'Claims',
    singularLower: 'claim',
    pluralLower: 'claims',
  },
})

const MUTUAL_GBS_SAI_TERMS = Object.freeze({
  policy: {
    singularTitle: 'Scheme',
    singularLower: 'scheme',
  },
  claim: {
    singularTitle: 'Payment Request',
    pluralTitle: 'Payment Requests',
    singularLower: 'payment request',
    pluralLower: 'payment requests',
  },
})

/**
 * Staff Absence / SAI terminology varies by department.
 *
 * - SAS/AIS: "Policy" + "Claims"
 * - Mutual/GBS: "Scheme" + "Payment Requests"
 */
export const getSaiTerminology = (policyDataOrDepartment) => {
  const department =
    typeof policyDataOrDepartment === 'string'
      ? policyDataOrDepartment
      : policyDataOrDepartment?.department

  if (isMutualGbsDepartment(department)) return MUTUAL_GBS_SAI_TERMS
  return DEFAULT_SAI_TERMS
}
